"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.insuranceModule = exports.InsuranceModules = void 0;
const typegate_1 = require("typegate");
// NOTE: Please update the README.md in shared/questionnaire-engine if this is modified.
exports.InsuranceModules = {
    insuranceApplication: 'insuranceApplication',
    needsAnalysis: 'needsAnalysis',
};
exports.insuranceModule = typegate_1.t.union(typegate_1.t.literal('insuranceApplication'), typegate_1.t.literal('needsAnalysis'));
